<ideal-image image [src]="thumbnailUrl()" *renderInProductDetailsView="LayoutTargets.Images; id: 'thumbnail'; priority: -1" />

<ideal-product-vendor-pod [productId]="id()" *renderInProductDetailsView="LayoutTargets.Vendor; id: 'vendor-info-pod'; priority: -1" />

<ideal-product-badges badges [productId]="id()" *renderInProductDetailsView="LayoutTargets.Badges; id: 'badges'; priority: -1" />
@if (specSheetUrl()) {
  <ideal-product-download-spec-sheet-button
    download-spec
    [productId]="id()"
    *renderInProductDetailsView="LayoutTargets.Badges; id: 'download-spec-sheet'; priority: -1"
  />
}
<ideal-product-is-canadian
  canadian
  [productId]="id()"
  *renderInProductDetailsView="LayoutTargets.Badges; id: 'is-canadian'; priority: -1"
/>

<ideal-product-section-cross-references
  xrefs
  [productId]="id()"
  *renderInProductDetailsView="LayoutTargets.Default; id: 'xrefs'; priority: -1"
/>
<ideal-product-section-specifications
  specifications
  [productId]="id()"
  *renderInProductDetailsView="LayoutTargets.Default; id: 'specifications'; priority: -1"
/>
<ideal-product-section-links links [productId]="id()" *renderInProductDetailsView="LayoutTargets.Default; id: 'links'; priority: -1" />
<ideal-product-alternates-section
  alternates
  [productId]="id()"
  *renderInProductDetailsView="LayoutTargets.Default; id: 'alternates'; priority: -1"
/>
<ideal-product-section-complimentary
  complimentary
  [productId]="id()"
  *renderInProductDetailsView="LayoutTargets.Default; id: 'complimentary'; priority: -1"
/>
@if (longDescription()) {
  <ideal-product-long-description
    long-description
    [productId]="id()"
    *renderInProductDetailsView="LayoutTargets.LongDescription; id: 'long-description'; priority: -1"
  />
}
